export default __webpack_public_path__ + "static/media/user_active.28eede6c.svg";